import { API_URL, requestData } from "./utils";
export default class BankAccountModule {
  requestQueryLink(query) {
    return requestData("GET", "/query/bank-account", query);
  }
  add(data) {
    return requestData("POST", "/bank-account", data);
  }
  addCSV(data) {
    return requestData("POST", "/bank-account/csv", data);
  }
  getBankAccountsCsvURL(
    query,
    link = "/download/csv/bankaccounts",
  ) {
    return API_URL + link + "?" + new URLSearchParams(query);
  }
  update(data, id) {
    return requestData("PUT", `/bank-account/${id}`, data);
  }
  delete(id) {
    return requestData("Delete", `/bank-account/${id}`);
  }
  assignBankAccount({
    assign_bank_account,
    enterprise_id,
    unassign_bank_account,
  }) {
    return requestData("POST", `/assign-bank-account/${enterprise_id}`, {
      assign_bank_account,
      unassign_bank_account,
    });
  }
}
